// extracted by mini-css-extract-plugin
module.exports = {"iframeContainer":"PodcastPlayer_iframeContainer__ncdch","iframeItem":"PodcastPlayer_iframeItem__i57lC","tabFont":"PodcastPlayer_tabFont__WOZYi"};